import type {RenewRepresentativeContractFormPayload} from "./renew-representative-contract.schema";

import {renewRepresentativeContract} from "@project/sdk/sales";
import {RenewRepresentativeContractBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../representative-keys";

import {renewRepresentativeContractMapper} from "./renew-representative-contract.mapper";

export function renewRepresentativeContractMutationOptions(representativeId: string) {
  return mutationOptions({
    mutationFn: (payload: RenewRepresentativeContractFormPayload) =>
      renewRepresentativeContract(
        representativeId,
        RenewRepresentativeContractBody.parse(renewRepresentativeContractMapper.toSdk(payload)),
      ),
    mutationKey: representativeMutationKeys.renewRepresentativeContract,
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)}),
        client.invalidateQueries({queryKey: representativeKeys.lists()}),
      ]);
    },
  });
}
